import React from 'react';
import { Outlet } from 'react-router-dom';
import styled, { css } from 'styled-components';
import NotificationContext from '../hooks/NotificationContext';
import AppBar from './AppBar';
import useNotifications from '../hooks/useNotifications';

const APP_BAR_HEIGHT = 50;
const PAGE_HEADER_HEIGHT = 20;
const PAGE_FOOTER_HEIGHT = 20;

const styles = css`
  display: flex;
  flex-direction: column;
  height: 100vh;

  > .app-bar {
    height: ${APP_BAR_HEIGHT}px;
  }

  > .page-header {
    height: ${PAGE_HEADER_HEIGHT}px;
  }
  > .page-footer {
    height: ${PAGE_FOOTER_HEIGHT}px;
  }

  > .page-wrapper {
      display: flex;
      height: calc(100vh - ${APP_BAR_HEIGHT + PAGE_FOOTER_HEIGHT + PAGE_HEADER_HEIGHT}px);
      overflow-y: scroll;
      justify-content: center;
      padding-left: 5px;
      padding-right: 5px;

    > .page {
      justify-content: left;
      align-items: flex-start;
      width: 100%;
      max-width: 1200px;
   }
  }

  @media print {
    > .page-wrapper {
        overflow-y: visible;
      }
    > .app-bar {
        display: none;
    }
  }
`;

const WrappedPage = ({ className }) => {
  const notifications = useNotifications();

  return (
    <div className={className}>
      <NotificationContext.Provider value={notifications}>
        <AppBar className='app-bar' />
        <div className='page-header'>
        </div>
        <div className='page-wrapper'>
          <div className='page'>
            <Outlet />
          </div>
        </div>
        <div className='page-footer'></div>
      </NotificationContext.Provider>
    </div>
  )
};

export default styled(WrappedPage)`${styles}`
